import React from 'react'
import { BaseStyled, HighlightStyled } from './Common.styles'

export const HighlightStat: React.FC<{
  title: string
  value?: string | null
  highlightOn: boolean
}> = ({ title, value, highlightOn }) => {
  const WrapperComponent = highlightOn ? HighlightStyled : BaseStyled
  return (
    <WrapperComponent>
      <strong>{title}</strong> {value}
    </WrapperComponent>
  )
}
